const local = {
  adminApiOrigin: "http://localhost:53490",
  adminPortalWebsiteOrigin: "http://localhost:19103",
};

const dev = {
  adminApiOrigin: "https://adminapi-dev.myschoolaccount.com",
  adminPortalWebsiteOrigin: "https://adminhq-dev.myschoolaccount.com",
};

const devDocker = {
  adminApiOrigin: "https://adminapidocker-dev.myschoolaccount.com",
  adminPortalWebsiteOrigin: "https://adminhqdocker-dev.myschoolaccount.com",
};

const test = {
  adminApiOrigin: "https://adminapi-test.myschoolaccount.com",
  adminPortalWebsiteOrigin: "https://adminhq-test.myschoolaccount.com",
};

const stage = {
  adminApiOrigin: "https://adminapi-stage.myschoolaccount.com",
  adminPortalWebsiteOrigin: "https://adminhq-stage.myschoolaccount.com",
};

const prod = {
  adminApiOrigin: "https://adminapi.myschoolaccount.com",
  adminPortalWebsiteOrigin: "https://adminhq.myschoolaccount.com",
};

const env = process.env.REACT_APP_ENV;

const config = {
  // Add common config here
  loginRoot: "/login",
  basename: "/app",
  ...(env === "local"
    ? local
    : env === "dev"
    ? dev
    : env === "devDocker"
    ? devDocker
    : env === "test"
    ? test
    : env === "stage"
    ? stage
    : prod),
};

export default config;
